import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rep-grp-summary',
  templateUrl: './rep-grp-summary.component.html',
  styleUrls: ['./rep-grp-summary.component.css']
})
export class RepGrpSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
